import { LOCALE } from '@enx/shared/util/constants';
import { DateTime } from 'luxon';

export class DateHelper {
  static getLocalDateTime(date: string): DateTime {
    return DateTime.fromISO(date, { zone: 'local' }).setLocale(LOCALE);
  }
}
